import { isUndefined, omitBy } from "lodash";

type WithoutUndefined<T extends object> = {
  [K in keyof T]?: Exclude<T[K], undefined>;
};

export const cleanEmptyProperties = <T extends object>(
  value: T,
): WithoutUndefined<T> => omitBy(value, isUndefined) as WithoutUndefined<T>;
